import Cookies from "js-cookie";
const WIKI_URL = process.env.VUE_APP_WIKI;
const TREASURE_NET_URL = process.env.VUE_APP_TREASURE_NET;
const state = {
  sidebar: {
    opened: Cookies.get("sidebarStatus")
      ? !!+Cookies.get("sidebarStatus")
      : true,
    withoutAnimation: false
  },
  device: "desktop",
  size: Cookies.get("size") || "medium",
  aboutTreasureUrl: WIKI_URL + "/en/treasureNetDescription",
  unitUrl: WIKI_URL + "/en/UnitIntroduction",
  TATUrl: WIKI_URL + "/en/TATIntroduction",
  FACE_URL: WIKI_URL + "/en/treasureNetDescription",
  GIT_URL: WIKI_URL + "/en/treasureNetDescription",
  IN_URL: WIKI_URL + "/en/treasureNetDescription",
  TELEGRAM_URL: WIKI_URL + "/en/treasureNetDescription",
  TWITTER_URL: "https://twitter.com/treasurenet_io",
  MEDIUM_URL: "https://medium.com/@treasurenet_io",
  TreasureNetVI_URL: WIKI_URL + "/en/TreasureNet-VI",
  Copyright_URL: WIKI_URL + "/en/treasureNetDescription",
  TREASURE_NET_URL: TREASURE_NET_URL,
  TREASURE_NET_LOGIN_URL: TREASURE_NET_URL + "/sign",
  QuickStart_URL: WIKI_URL + "/en/new-page",
  MetaMaskObj:{
    isInstall:false,
    isConnect:false,
    isJoinNet:false,
    account:null,
    initOk:false,
    privateKey:'0x37a96ceb2116d3c5a273b824f824cee4f85a45a323020901869cd47f043b292f',
    stopRefreshJoinNet:false
  },
  contractMap:{
    contractGovernance:{},
    contractDao:{},
    contractBid:{},
    contractTAT:{},
    contractUnitPrice:{},
    contractUSTN:{},
    contractUSTNFinance:{},

  },
  bidStatusMap:{
    "SUCCESS":"Succeeded", // start
    "FALSE":"fail",
    "INVAILD":"Invalid",
  },
  auctionStatusMap:{
    "status_1":"In auction", // start
    "status_2":"In auction",
    "status_3":"Auction ends",
  },
  voteStatusMap:{
    "status_1":"Ongoing",
    "status_2":"Passed",
    "status_3":"Failed",
  },
  proposalStatus:[
    {
      value:"0",
      label:"All"
    },
    {
      value:"1",
      label:"Ongoing"
    },
    {
      value:"2",
      label:"Passed"
    },
    {
      value:"3",
      label:"Failed"
    }
  ],
  proposalExecutedStatus:[
    {
      value:"4",
      label:"Execute"
    },
    {
      value:"5",
      label:"Executed"
    }
  ],
  proposalType:[
    {
      value:"3",
      label:"Change role permissions-Auditor",
      children:[
        {
          value:"Feeder",
          label:"Feeder"
        },
        {
          value:"Auditor",
          label:"Auditor"
        },
        {
          value:"FoundationManager",
          label:"FoundationManager"
        }
      ]
    },
    {
      value:"4",
      label:"Add mineral type"
    },
    {
      value:"2",
      label:"Change oil price discount parameters",
      children:[
        {
          value:"API",
          label:"API Gravity",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"sulphur",
          label:"Sulphur Content",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"d1",
          label:"Discount rate1",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"d2",
          label:"Discount rate2",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"d3",
          label:"Discount rate3",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"d4",
          label:"Discount rate4",
          min:0,
          max:100,
          type:"number"
        }
      ]
    },
    {
      value:"1",
      label:"Change platform parameters",
      children:[
        {
          value:"marginRatio",
          label:"Producer Deposit Deduction Ratio",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"reserveRatio",
          label:"Required Reserve Ratio",
          min:0,
          max:100,
          type:"number"
        },
        {
          value:"loanInterestRate",
          label:"Daily Interest Rate",
          min:0,
          max:0.1,
          type:"number"
        },
        {
          value:"loanPledgeRate",
          label:"Collatoral Ratio",
          min:120,
          max:666,
          type:"number"
        },
        // {
        //   value:"loanPledgeRateWarningValue",
        //   label:"Early warning pledge rate",
        //   min:100,
        //   max:125,
        //   type:"number"
        // },
        {
          value:"loanLiquidationRate",
          label:"Liquidation Threshold",
          // min:90,
          // max:95,
          type:"number"
        },
      ]
    }
  ],
  gas:"500000",
  currentNetwork: 'Treasurenet', // 默认网络
};

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_SIZE: (state, size) => {
    state.size = size;
    Cookies.set("size", size);
  },
  SET_MATEMASK: (state, obj) => {
    if(obj){
      for(let k in obj){
        state.MetaMaskObj[k] = obj[k];
      }
    }
  },
  SET_CONTRACTMAP: (state, data) => {
    state.contractMap[data.key] = data.value;
  },
  SET_CURRENT_NETWORK: (state, network) => {
    state.currentNetwork = network;
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device);
  },
  setSize({ commit }, size) {
    commit("SET_SIZE", size);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
